export default "/institutions/caixa.svg";